import { useEffect } from "react";
import { postRegulationsNextHomeToParent } from "../../utils/regulationsNextIframeHome";

/**
 * Shell / iframe integration shared by Regulations Next homepage-style entry pages.
 */
export function useRegulationsNextShellIntegration(): void {
  useEffect(() => {
    const cleanUrlParams = () => {
      try {
        const topWin = window.top;
        if (topWin && topWin !== window.self) {
          const u = new URL(topWin.location.href);
          if (
            u.searchParams.has("modulePath") ||
            u.searchParams.has("version")
          ) {
            u.searchParams.delete("modulePath");
            u.searchParams.delete("version");
            topWin.history.replaceState(
              topWin.history.state,
              "",
              u.pathname + u.search + u.hash,
            );
          }
          postRegulationsNextHomeToParent();
        }

        const selfUrl = new URL(window.location.href);
        if (selfUrl.searchParams.has("modulePath")) {
          selfUrl.searchParams.delete("modulePath");
          window.history.replaceState(
            window.history.state,
            "",
            selfUrl.pathname + selfUrl.search + selfUrl.hash,
          );
        }
      } catch {
        postRegulationsNextHomeToParent();
      }
    };

    cleanUrlParams();
  }, []);
}
